__webpack_require__.p = "/DIC_Project_Web_UI/";